<!--Списковая Антихрупкости-->
<template>
	<div>
		<short-header />
		<div class="search-header theme-light">
			<div class="panel_header">
				<div id="scroll-on-page-change" class="container">
					<h1 v-if="taxonomyType !==''">
						Анонсы ближайших событий: {{ selectedTaxonomyTypeTitle }}
					</h1>
					<h1 v-else>
						Анонсы ближайших событий
					</h1>
					<search v-model="search" />
					<div class="row">
						<client-only>
							<dropdown
								v-model="taxonomyType"
								label="Формат:"
								:options="taxonomyTypes"
							/>
							<dropdown
								v-model="taxonomySection"
								label="Профильный раздел:"
								:options="actualTaxonomySections"
							/>
							<dropdown
								v-model="taxonomyProject"
								label="Бизнес направление:"
								:options="taxonomyProjects"
							/>
							<dropdown
								v-model="taxonomyProduct"
								label="Продукт:"
								:options="taxonomyProducts"
							/>
							<dropdown
								v-model="isFree"
								label="Стоимость участия:"
								:options="freeFilters"
								:label-any-value="false"
							/>
						</client-only>
						<b-col cols="12" md="6" mb="3" lg="3" class="overflow-auto text-center">
							<div>&nbsp;</div>
							<b-form-checkbox
								v-model="showPast"
								switch
							>
								Показать прошедшие события
							</b-form-checkbox>
						</b-col>
					</div>
				</div>
			</div>
		</div>
		<b-container v-if="$fetchState.pending" class="d-flex justify-content-center mb-3">
			<b-spinner
				style="width: 3em; height: 3em; margin-right: 10px;"
			/>
		</b-container>
		<b-container v-else-if="$fetchState.error">
			{{ $fetchState.error }}
		</b-container>
		<b-container v-else-if="events && events.data && events.data.length === 0">
			<b-alert show class="d-flex justify-content-center mb-3">
				По вашему запросу ничего не найдено
			</b-alert>
		</b-container>
		<template v-else-if="events && events.data">
			<event-navigator-items :items="events.data" />
			<b-pagination
				v-model="page"
				:total-rows="events.meta && events.meta.total || 0"
				:per-page="events.meta && events.meta.per_page || 0"
				:limit="7"
				align="center"
				pills
				hide-goto-end-buttons
				next-class="pagination-next"
				prev-class="pagination-prev"
				prev-text=""
				next-text=""
			/>
		</template>
		<issue-upcoming-events />
		<main-footer />
	</div>
</template>

<script>
import jsonldForItemList from '@/utils/seo/jsonldForItemList';
import searchMixin from '~/mixins/searchMixin';
import taxonomyMixin from '~/mixins/taxonomyMixin';
import createJivoMixin from '~/mixins/createJivoMixin';

import Dropdown from '~/components/Dropdown.vue';
import Search from '~/components/refactor/Search.vue';
import MainFooter from '~/components/layouts/footers/MainFooter.vue';
import ShortHeader from '~/components/layouts/headers/ShortHeader.vue';
import EventNavigatorItems from '~/components/refactor/EventNavigatorItems.vue';
import IssueUpcomingEvents from '~/components/blocks/issue/IssueUpcomingEvents.vue';
import makeCanonicalLink from '~/utils/seo/makeCanonicalLink';

export default {
	components: {
		ShortHeader,
		EventNavigatorItems,
		MainFooter,
		IssueUpcomingEvents,
		Search,
		Dropdown,
	},
	mixins: [taxonomyMixin, searchMixin, createJivoMixin()],
	async asyncData({ app, query }) {
		const { $pagesApi } = app;
		const searchValue = query.search || '';

		const [taxonomy] = await Promise.all([
			$pagesApi.taxonomy(),
		]);

		return { taxonomy, searchValue };
	},
	data() {
		return {
			events: null,
			freeFilters: {
				'': 'Все',
				true: 'Бесплатные',
				false: 'Платные',
			},
		};
	},
	async fetch() {
		const { query } = this.$route;
		const params = {
			per_page: 12,
			page: query.page || 1,
			search: query.search || '',
			// typology: 0,
			category: query.category,
			type: query.taxonomy_type || '',
			taxonomy_project: query.taxonomy_project || '',
			taxonomy_product: query.taxonomy_product || '',
			taxonomy_section: query.taxonomy_section || '',
			taxonomy_topic: query.taxonomy_topic || '',
			is_free: query.free,
			hide_fixed: true,
			hide_past: !query.show_past,
			only_past: query.show_past,
			order_by: query.show_past ? 'desc' : 'asc',
			test: 0,
		};
		this.events = await this.$api.events(params);
	},
	jsonld() {
		let data = {};
		try {
			data = jsonldForItemList(this.events);
		} catch (e) {
			this.$logger.log(e);
		}

		return data;
	},
	head() {
		return {
			title: 'Анонсы ближайших событий',
			meta: [
				{
					name: 'description',
					hid: 'description',
					content: '',
				},
				{
					hid: 'robots',
					name: 'robots',
					content: 'noindex, nofollow',
				},
			],
			link: [
				{
					rel: 'canonical',
					hid: 'canonical',
					href: makeCanonicalLink(this.$route.path),
				},
			],
		};
	},
	computed: {
		actualTaxonomySections() {
			if (typeof this.taxonomySections !== 'object') return {};
			return Object.entries(this.taxonomySections).reduce((acc, [id, cur]) => {
				acc[id] = cur.title;
				return acc;
			}, {});
		},
		isFreeTitle() {
			return this.freeFilters[this.isFree];
		},
		isFree: {
			get() {
				return this.$route.query.free || '';
			},
			set(isFree) {
				this.$router.push({
					query: {
						...this.$route.query,
						free: isFree || undefined,
						page: undefined,
					},
				});
			},
		},
		showPast: {
			get() {
				return this.$route.query.show_past || false;
			},
			set(showPast) {
				this.$router.push({
					query: {
						...this.$route.query,
						show_past: showPast || undefined,
						page: undefined,
					},
				});
			},
		},
		page: {
			get() {
				return this.$route.query.page || 1;
			},
			set(page) {
				this.$router.push({
					query: {
						...this.$route.query,
						page: page > 1 ? page : undefined,
					},
				});
			},
		},
	},
	watch: {
		'$route.query': {
			async handler() {
				this.$scrollTo('#scroll-on-page-change');
				this.$fetch();
			},
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/layouts/event-search-header";
</style>

<style lang="scss">
	// top_menu z-index: 1010
	// 1000
	.dropdown-menu {
		z-index: 1020;
	}
</style>
